import { toGfxBlockComponent } from '@blocksuite/std';
import { css } from 'lit';

import { ImagePlaceholderBlockComponent } from './page.js';

export class ImageEdgelessPlaceholderBlockComponent extends toGfxBlockComponent(
  ImagePlaceholderBlockComponent
) {
  static override styles = css`
    hive-edgeless-placeholder-preview-image
      .hive-placeholder-preview-container {
      border: 1px solid var(--hive-background-tertiary-color);
    }
  `;

  override renderGfxBlock(): unknown {
    return super.renderGfxBlock();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'hive-edgeless-placeholder-preview-image': ImageEdgelessPlaceholderBlockComponent;
  }
}
